/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type { BannerSearchRequestDto, BannerSearchResponseDto } from '@as-react/common-types/booster-service';
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, QueryClient, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryFetch } from '../../utils/orval/queryFetch';
import { useQueryFetch } from '../../utils/orval/useQueryFetch';
import type { ErrorType, BodyType } from '../../utils/orval/useQueryFetch';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Search for banners by location
 */
export const useGetZitchaBannerHook = () => {
  const getZitchaBanner = useQueryFetch<Array<BannerSearchResponseDto>>();

  return useCallback(
    (
      mainWebShopId: number,
      bannerSearchRequestDto: BodyType<BannerSearchRequestDto>,
      operationName = 'getZitchaBanner',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getZitchaBanner(
        {
          url: `/api/zitcha/search/banners/${mainWebShopId}`,
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          data: bannerSearchRequestDto,
          signal,
        },
        { operationName: 'getZitchaBanner', ...options }
      );
    },
    [getZitchaBanner]
  );
};

export const useGetZitchaBannerMutationOptions = <
  TError = ErrorType<Array<BannerSearchResponseDto>>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useGetZitchaBannerHook>>>,
    TError,
    { mainWebShopId: number; data: BodyType<BannerSearchRequestDto>; operationName?: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useGetZitchaBannerHook>>>,
  TError,
  { mainWebShopId: number; data: BodyType<BannerSearchRequestDto>; operationName?: string },
  TContext
> => {
  const mutationKey = ['getZitchaBanner'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const getZitchaBanner = useGetZitchaBannerHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useGetZitchaBannerHook>>>,
    { mainWebShopId: number; data: BodyType<BannerSearchRequestDto>; operationName?: string }
  > = props => {
    const { mainWebShopId, data, operationName } = props ?? {};

    return getZitchaBanner(mainWebShopId, data, operationName, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetZitchaBannerMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetZitchaBannerHook>>>>;
export type GetZitchaBannerMutationBody = BodyType<BannerSearchRequestDto>;
export type GetZitchaBannerMutationError = ErrorType<Array<BannerSearchResponseDto>>;

/**
 * @summary Search for banners by location
 */
export const useGetZitchaBanner = <TError = ErrorType<Array<BannerSearchResponseDto>>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useGetZitchaBannerHook>>>,
      TError,
      { mainWebShopId: number; data: BodyType<BannerSearchRequestDto>; operationName?: string },
      TContext
    >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useGetZitchaBannerHook>>>,
  TError,
  { mainWebShopId: number; data: BodyType<BannerSearchRequestDto>; operationName?: string },
  TContext
> => {
  const mutationOptions = useGetZitchaBannerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Search for banners by location
 */
export const getZitchaBannerServer = (
  mainWebShopId: number,
  bannerSearchRequestDto: BannerSearchRequestDto,
  operationName = 'getZitchaBanner',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<BannerSearchResponseDto>>(
    {
      url: `/public/zitcha/search/banners/${mainWebShopId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: bannerSearchRequestDto,
      signal,
    },
    { operationName: 'getZitchaBanner', ...options }
  );
};

export const getGetZitchaBannerServerMutationOptions = <
  TError = ErrorType<Array<BannerSearchResponseDto>>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getZitchaBannerServer>>,
    TError,
    { mainWebShopId: number; data: BannerSearchRequestDto; operationName?: string },
    TContext
  >;
  request?: SecondParameter<typeof queryFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getZitchaBannerServer>>,
  TError,
  { mainWebShopId: number; data: BannerSearchRequestDto; operationName?: string },
  TContext
> => {
  const mutationKey = ['getZitchaBannerServer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getZitchaBannerServer>>,
    { mainWebShopId: number; data: BannerSearchRequestDto; operationName?: string }
  > = props => {
    const { mainWebShopId, data, operationName } = props ?? {};

    return getZitchaBannerServer(mainWebShopId, data, operationName, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetZitchaBannerServerMutationResult = NonNullable<Awaited<ReturnType<typeof getZitchaBannerServer>>>;
export type GetZitchaBannerServerMutationBody = BannerSearchRequestDto;
export type GetZitchaBannerServerMutationError = ErrorType<Array<BannerSearchResponseDto>>;

/**
 * @summary Search for banners by location
 */
export const useGetZitchaBannerServer = <TError = ErrorType<Array<BannerSearchResponseDto>>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getZitchaBannerServer>>,
      TError,
      { mainWebShopId: number; data: BannerSearchRequestDto; operationName?: string },
      TContext
    >;
    request?: SecondParameter<typeof queryFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getZitchaBannerServer>>,
  TError,
  { mainWebShopId: number; data: BannerSearchRequestDto; operationName?: string },
  TContext
> => {
  const mutationOptions = getGetZitchaBannerServerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
